import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const AdManagerBanner = ({ bannerName, tagName }) => {
  const [bannerSource, setBannerSource] = useState(false);

  const tag = tagName || 'div';
  const params = new URLSearchParams(window.location.search);
  const showBannerParam = params.get('digital_snail');

  const AdManagerBanners = {
    catfish: {
      bannerId: '/22595893243/Bina.az/Bina.az_Catfish_desk',
      blockId: 'google-buds-catfish-banner',
      sizes: [700, 120]
    },
    top: {
      bannerId: '/22595893243/Bina.az/Bina.az_mobile_top',
      blockId: 'google-buds-top-banner',
      sizes: [320, 100]
    },
    deskTop: {
      bannerId: '/22595893243/Bina.az/Bina.az_desk_top',
      blockId: 'google-buds-desktop-top-banner',
      sizes: [2000, 120]
    },
    bottom: {
      bannerId: '/22595893243/Bina.az/Bina.az_mobile_bottom',
      blockId: 'google-buds-bottom-banner',
      sizes: [320, 100]
    },
    bg: {
      bannerId: '/22595893243/Bina.az/Bina.az_Desk_background',
      blockId: 'google-buds-bg-banner',
      sizes: [1440, 1000]
    },
    search: {
      bannerId: '/22595893243/Bina.az/Bina.az_insearch_desk',
      blockId: 'google-buds-search-banner',
      sizes: [960, 180]
    }
  };

  const handleAndLoadBanner = () => {
    const banner = document.querySelector(`#js-lotriver-${bannerName}-banner`);
    const bannerIframe = document.querySelector(
      `#js-lotriver-${bannerName}-banner iframe`
    );

    if (bannerIframe) {
      bannerIframe.setAttribute('title', 'Interactive content');
    }

    setTimeout(() => {
      bannerIframe?.addEventListener('load', () => {
        if (banner?.clientHeight === 0) {
          setBannerSource(true);
        } else {
          setBannerSource(false);
        }
      });
    }, 100);
  };

  useEffect(() => {
    handleAndLoadBanner();
    if (typeof window !== 'undefined' && bannerSource) {
      const googletag = window.googletag || { cmd: [] };
      googletag.cmd.push(() => {
        googletag
          .defineSlot(
            AdManagerBanners[bannerName].bannerId,
            AdManagerBanners[bannerName].sizes,
            AdManagerBanners[bannerName].blockId
          )
          ?.addService(googletag.pubads());

        googletag.enableServices();
      });

      setTimeout(() => {
        googletag.cmd.push(() => {
          googletag.display(AdManagerBanners[bannerName].blockId);
        });
      }, 0);
    }
  }, [bannerName, bannerSource]);

  return (
    bannerSource &&
    showBannerParam &&
    React.createElement(
      tag,
      {
        id: AdManagerBanners[bannerName]?.blockId,
        className: AdManagerBanners[bannerName]?.blockId,
        style: {
          minWidth: AdManagerBanners[bannerName]?.sizes[0],
          minHeight: AdManagerBanners[bannerName]?.sizes[1]
        }
      },
      null
    )
  );
};

AdManagerBanner.propTypes = {
  bannerName: PropTypes.string,
  tagName: PropTypes.string
};

export default AdManagerBanner;
